import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import CartOrderItem from './CartOrderItem';
import CartDiscount from './CartDiscount';
import styles from './Cart.scss';
import CartEmptyState from './CartEmptyState';
import CartSummary from './CartSummary';
import PlaceOrderButton from '../PlaceOrderButton';
import { SPECIAL_KEY_SYMBOL } from '../../utils/enviormentUtils';

import { Text, Input, Button, TextButton, Tooltip } from 'wix-style-react';

class Cart extends React.PureComponent {
  static propTypes = {
    orderItems: PropTypes.array,
    itemsHash: PropTypes.object,
    t: PropTypes.func,
    locale: PropTypes.string,
    currency: PropTypes.string,
    discounts: PropTypes.array,
    onOrderItemCountChange: PropTypes.func,
    onDishSelect: PropTypes.func,
    onGoToCheckout: PropTypes.func,
    discountInputValue: PropTypes.number,
    onManagerDiscountChange: PropTypes.func,
    acceptsTip: PropTypes.bool,
    allowsManagerDiscount: PropTypes.bool,
    displayGoToCheckout: PropTypes.bool,
    displayPlaceOrder: PropTypes.bool,
    onCancelOrderClick: PropTypes.func,
    onChangeSpecialRequest: PropTypes.func,
  };

  static defaultProps = {
    orderItems: [],
    itemsHash: {},
    discounts: [],
    priceComponents: {},
    onDishSelect: () => null,
    displayGoToCheckout: true,
    displayPlaceOrder: true,
  };

  renderOrderItems() {
    const { itemsHash, orderItems, locale, currency, onOrderItemCountChange, onDishSelect } = this.props;

    return (
      <div className={styles.orderItems} data-hook="cart-items-wrapper">
        {orderItems.map((orderItem, cartIndex) => (
          <CartOrderItem
            key={cartIndex}
            orderItem={orderItem}
            itemsHash={itemsHash}
            locale={locale}
            currency={currency}
            onIncrease={onOrderItemCountChange}
            onDecrease={onOrderItemCountChange}
            cartIndex={cartIndex}
            onClick={onDishSelect}
          />
        ))}
      </div>
    );
  }

  renderDiscounts() {
    const { discounts, currency, locale } = this.props;
    return (
      <div className={styles.discounts} data-hook="cart-discounts-wrapper">
        {discounts.map(discount => (
          <CartDiscount key={discount.groupId} discount={discount} currency={currency} locale={locale} />
        ))}
      </div>
    );
  }

  changeSpecialRequest = e => this.props.onChangeSpecialRequest({ value: e.target.value });

  render() {
    const {
      orderItems,
      locale,
      currency,
      priceComponents,
      onGoToCheckout,
      onManagerDiscountChange,
      discountInputValue,
      t,
      acceptsTip,
      onChangeDeliveryFee,
      allowsManagerDiscount,
      deliveryType,
      displayGoToCheckout,
      displayPlaceOrder,
      onCancelOrderClick,
    } = this.props;
    const cancelOrderTooltip = `${t('phoneordering_keyboardShortcut_cancelorder_tooltip')} (${SPECIAL_KEY_SYMBOL} + O)`;
    const gotoCheckoutTooltip = `${t('phoneordering_keyboardShortcut_gocheckout_tooltip')} (${SPECIAL_KEY_SYMBOL} + Enter)`;
    const hasItems = orderItems.length > 0;
    return (
      <div className={styles.wrapper}>
        {hasItems && (
          <React.Fragment>
            <div className={styles.content} data-hook="cart-items-wrapper">
              {this.renderOrderItems()}
              {this.renderDiscounts()}
            </div>

            <Text
              size="medium"
              tagName="div"
              weight="thin"
              className={styles.specialRequest}
              data-hook="special-request-wrapper"
            >
              <div className={styles.specialRequestTitle}>{t('phoneordering_checkout_requests_label')}</div>
              <Input
                onChange={this.changeSpecialRequest}
                dataHook="special-request-input"
                placeholder={t('phoneordering_checkout_requests_placeholder')}
              />
            </Text>

            <CartSummary
              allowsManagerDiscount={allowsManagerDiscount}
              acceptsTip={acceptsTip}
              priceComponents={priceComponents}
              locale={locale}
              currency={currency}
              discountInputValue={discountInputValue}
              onManagerDiscountChange={onManagerDiscountChange}
              onChangeDeliveryFee={onChangeDeliveryFee}
              deliveryType={deliveryType}
            />
          </React.Fragment>
        )}

        {!hasItems && <CartEmptyState t={t} />}

        <div className={styles.footer}>
          {displayGoToCheckout && (
            <Text size="medium" weight="normal" secondary className={styles.button}>
              <Tooltip enterDelay={500} size={'small'} content={gotoCheckoutTooltip}>
                <Button
                  onClick={() => onGoToCheckout()}
                  size="large"
                  dataHook="cart-go-to-checkout"
                  disabled={!hasItems}
                  fullWidth
                >
                  {t('phoneordering_checkout_checkout_cta')}
                </Button>
              </Tooltip>
            </Text>
          )}

          {displayPlaceOrder && (
            <div className={styles.button}>
              <PlaceOrderButton fullWidth />
            </div>
          )}
          <Tooltip enterDelay={500} size={'small'} content={cancelOrderTooltip}>
            <div className={styles.button}>
              <TextButton dataHook="cart-cancel-order" onClick={onCancelOrderClick} style={{color:"#ee5951"}}>
                {t('phoneordering_agentsettings_cancelorder_cta')}
              </TextButton>
            </div>
          </Tooltip>
        </div>
      </div>
    );
  }
}

export default translate()(Cart);
